var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"scontent"},[_c('sl-loading')],1):_c('div',{staticClass:"scontent"},[_c('div',{staticStyle:{"height":"0","max-height":"0"}},[_c('menu-projeto',{ref:"menuProjeto"}),_c('project-tab',{attrs:{"projeto":_vm.projeto}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }